import { Container, Flex, Text } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { CoverageSuggestionCard } from "./CoverageSuggestionCard";
import type { CoverageSuggestionsProps } from "./types";

export const CoverageSuggestions = ({
  ref,
  ...props
}: CoverageSuggestionsProps) => {
  const {
    title = "Unsure what insurance you need for your business?",
    subtitle = "These covers are the most popular for businesses like yours.",
    suggestions,
    className,
    ...otherProps
  } = props;

  const classes = classNames(
    "mobius",
    "mobius-coverage-suggestions",
    className,
  );

  return (
    <Container
      size="sm"
      ref={ref}
      className={classes}
      data-testid="coverage-suggestions"
      {...otherProps}
    >
      <Flex flexDirection="column" gap="md">
        <div className="mobius-coverage-suggestions__header">
          <Text
            elementType="h2"
            variant="h2"
            className="mobius-coverage-suggestions__title"
          >
            {title}
          </Text>
          <Text className="mobius-coverage-suggestions__subtitle">
            {subtitle}
          </Text>
        </div>

        <div
          className="mobius-coverage-suggestions__grid"
          data-testid="coverage-suggestions-grid"
        >
          {suggestions.map((suggestion, index) => (
            <CoverageSuggestionCard
              key={`${suggestion.name}-${index}`}
              suggestion={suggestion}
            />
          ))}
        </div>
      </Flex>
    </Container>
  );
};

CoverageSuggestions.displayName = "CoverageSuggestions";
